import React from "react";
import {connect} from "react-redux";
import PropTypes from "prop-types";

import TextInput from "../Generic/textInput";
import {jobInterface} from "./jobInterface";
import {updateJob, updateJobName} from "./JobBoardActions";

const JobBoardJobCustomName = (props) => {
  const {job, updateJob, updateJobName} = props;

  const onCustomNameChange = (name) => {
    updateJob(job, {customName: name});
  }

  const onCustomNameBlur = (name) => {
    updateJobName(job, name);
  }

  return (
    <div className="job-board-custom-name">
      <TextInput className={`discount-name ui-input ui-input--gray4 ui-input--gray4--small`}
                 placeholder=""
                 // onFocus={() => setWizardNodeInputFocused(true)}
                 onBlur={onCustomNameBlur}
                 onChange={onCustomNameChange}
                 maxLength={300}
                 value={job.customName || ""}/>
    </div>
  )
};

JobBoardJobCustomName.propTypes = {
  job: PropTypes.shape(jobInterface).isRequired,
};

const mapStateToProps = () => {
  return {

  };
};

const mapDispatchToProps = {
  updateJob,
  updateJobName,
};

export default connect(mapStateToProps, mapDispatchToProps)(JobBoardJobCustomName)
